import SingleLoanViewLayout from "components/tenders/singleLoan/SingleLoanViewLayout";
import { useNavigate, useParams } from 'react-router';
import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { TranslateString, convertToObjectKeyString } from "Utils/Common";
import { message, Modal } from "antd";
import { useState, useEffect } from "react";
import LoanOfferComparison from "components/tenders/singleLoan/LoanOfferComparison";
import SingleLoanServices from "services/services/SingleLoanServices";
import { useIntl } from 'react-intl';
import { useSearchParams } from "react-router-dom";

var htmlPdfClient = require("html-pdf-client")

function LoanComparisonPdf(props: any) {
    const navigate = useNavigate();
    const id:any = useParams();
    const [btnClick, setBtnClick] = useState<any>((id?.loan_comparision_tab==2?2:1));
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [btnState, setBtnState] = useState<any>();
    const [disableBtn, setDisableBtn] = useState(false);
    const [showPrintBtn, setPrintShowBtn] = useState(false);
    const [headerText, setHeaderText] = useState('');
    // const [loanData, setLoanData] = useState<any>();
    const intl=useIntl();
    const [printBtn, setPrintBtn] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const showbtn = searchParams.get("showbtn");

    const handleOk = () => {
        if (id) navigate('/end-tendering/' + id.loan_tender_id);
    }

    useEffect(()=>{
        getLoanData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])
    const getLoanData = () => {
        setLoading(true);
        let paramsId = id.loan_tender_id
        SingleLoanServices
            .getSingleLoanData(paramsId)
            .then((response: any) => {
                if (response?.data?.code === 200) {
                    const responseVal = response?.data?.data
                    // setLoanData(responseVal)
                    setHeaderText(responseVal.LOAN_DATA.loan_data_customername.trim() + ', ' +responseVal.LOAN_DATA.loan_data_name.trim())
                }
                setLoading(false);
            })
            .catch((err: any) => {
                console.log(err)
                setLoading(false);
            });
    };
    const handleServiceHm = () => {
        let obj: any = {}
        obj.customer_id = id?.id;

        setLoading(true);
        SingleLoanServices
            .updateHmService(obj,id?.loan_tender_id)
            .then((response: any) => {
                if (response?.data?.code === 200) {
                    message.success(intl.formatMessage({id: convertToObjectKeyString('service_request_sent_to_hm')}));
                    setOpen(false)
                    setLoading(false);
                }
            })
            .catch((err: any) => {
                console.log(err)
                setLoading(false);
            });
    }

    const handleCancelPop = () => {
        setOpen(false);
    };

    const print = async () => {
        var element: any = document.getElementById('loan-offer-comparison');
        setPrintBtn(true);

        var opt = {
            margin: 0.1,
            filename: 'Lainavertailu '+ headerText + '.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'in', format: 'A4', orientation: 'landscape', compressPDF: true },
            pagebreak: { mode: 'avoid-all', before: '.page-break' }
        };
        setPrintShowBtn(true);
        // New Promise-based usage:
        await htmlPdfClient().set(opt).from(element).save();
        setPrintBtn(false);
        setPrintShowBtn(false);
    }

    return (
        <>
            <div className="ant-card ant-card-bordered cu-mb-10 cu-px-10 w-100 text-left cu-tab-text">
                <h4 className="cu-m-0 cu-p-0">
                    <button className="ant-btn cu-border-0 h4 pl-0 align-middle mb-0">{ (showbtn === '0' ? 'Lainavertailu' : TranslateString('loan_comparison'))}: {headerText}</button>
                </h4>
            </div>
            <div className="cu-table-small cu-card-padding">
                {btnClick === 1 &&
                    <SingleLoanViewLayout {
                        ...{ ...props, ...id }}
                        setDisableBtn={setDisableBtn}
                        type={`admin`}
                    />}
                {btnClick === 2 && <div id="loan-offer-comparison"><LoanOfferComparison {...{ ...props, ...id }} printBtn={printBtn} headerText={headerText} printShow={showPrintBtn}/></div>}
            </div>
        </>
    );
}

export default LoanComparisonPdf;